import type { FaireProductEntity } from "../../entity_types/product";

export const p_9dd2jn939w: FaireProductEntity = {
  token: "p_9dd2jn939w",
  type: "product",
  name: "Cuerda Hoops",
  brandToken: "b_b01ri6tu6x",
  brandName: "Kisiwa",
  imageUrl:
    "https://cdn.faire.com/fastly/8b2d314bc5c98f54925a7764dbc55d6648a26aab14c8bd57583b1c39acc976ac.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/07ffd11fab1c47746577661f2b6ca49ed70eedd1072c5c76d312481b96f3609f.jpeg",
    "https://cdn.faire.com/fastly/b99cc8ba3ebea20b3c5ae0921aefe1f2981cf001cdf685930d1dec978f0babc7.jpeg",
    "https://cdn.faire.com/fastly/41a522e5e98e67adb2274dc2c7e761e96292e441736cb8795f3cdc05d71d8c94.jpeg",
  ],
  priceDollars: 70,
  description:
    "Handwoven high-quality Japanese glass beads on handmade gold-filled hoops. This listing is for one pair of hoops (1.5”x1.5”). I make each one different so that the pair is purposefully unmatched.",
  tags: [],
  msrpDollars: 140,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:37:42.144Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
